export const sideMenuVariants = {
  hidden: {
    x: '-100%',
  }, show: {
    x: 0
  }
}
